import { render, staticRenderFns } from "./workers.vue?vue&type=template&id=3cd99d28&scoped=true&"
import script from "./workers.vue?vue&type=script&lang=js&"
export * from "./workers.vue?vue&type=script&lang=js&"
import style0 from "./workers.vue?vue&type=style&index=0&id=3cd99d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd99d28",
  null
  
)

export default component.exports